import { memo } from 'react';

const Footer = memo(() => {
  return (
    <footer id="footer" className="footer dark-background">
      <div className="footer-top">
        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-4 col-md-6 footer-about">
              <a href="#hero" className="logo d-flex align-items-center">
                <span className="sitename">TuLogo</span>
              </a>
              <div className="footer-contact pt-3">
                <p>Concepción, Chile</p>
                <p className="mt-3">
                  <strong>Teléfonos:</strong>
                </p>
                <p>
                  <span>+56 41 215 9280</span>
                </p>
                <p>
                  <span>+56 41 332 6622</span>
                </p>
                <p>
                  <strong>Email:</strong> <span>bsanhueza@cloudata.cl</span>
                </p>
              </div>
              <div className="social-links d-flex mt-4">
                <a href="#">
                  <i className="bi bi-whatsapp"></i>
                </a>
                <a href="#">
                  <i className="bi bi-facebook"></i>
                </a>
                <a href="#">
                  <i className="bi bi-instagram"></i>
                </a>
                <a href="#">
                  <i className="bi bi-linkedin"></i>
                </a>
              </div>
            </div>

            <div className="col-lg-2 col-md-3 footer-links">
              <h4>Enlaces Rápidos</h4>
              <ul>
                <li>
                  <i className="bi bi-chevron-right"></i> <a href="#hero">Inicio</a>
                </li>
                <li>
                  <i className="bi bi-chevron-right"></i> <a href="#about">Nosotros</a>
                </li>
                <li>
                  <i className="bi bi-chevron-right"></i> <a href="#services">Servicios</a>
                </li>
                <li>
                  <i className="bi bi-chevron-right"></i> <a href="#team">Por qué elegirnos</a>
                </li>
                <li>
                  <i className="bi bi-chevron-right"></i> <a href="#contact">Contacto</a>
                </li>
              </ul>
            </div>

            <div className="col-lg-2 col-md-3 footer-links">
              <h4>Nuestros Servicios</h4>
              <ul>
                <li>
                  <i className="bi bi-chevron-right"></i> <a href="#services">Rastreo GPS 24/7</a>
                </li>
                <li>
                  <i className="bi bi-chevron-right"></i> <a href="#services">Sistemas de Videovigilancia</a>
                </li>
                <li>
                  <i className="bi bi-chevron-right"></i> <a href="#services">Soporte Remoto</a>
                </li>
                <li>
                  <i className="bi bi-chevron-right"></i> <a href="#services">Desarrollo de Proyectos</a>
                </li>
                <li>
                  <i className="bi bi-chevron-right"></i> <a href="#services">Mantenimiento TI</a>
                </li>
              </ul>
            </div>

            <div className="col-lg-4 col-md-12 footer-newsletter">
              <h4>Boletín Informativo</h4>
              <p>Suscríbete para recibir las últimas novedades sobre nuestros servicios y tecnologías</p>
              <form action="forms/newsletter.php" method="post" className="php-email-form">
                <div className="newsletter-form">
                  <input type="email" name="email" placeholder="Tu correo electrónico" />
                  <input type="submit" value="Suscribirse" />
                </div>
                <div className="loading">Cargando</div>
                <div className="error-message"></div>
                <div className="sent-message">¡Gracias por suscribirte!</div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className="copyright">
        <div className="container text-center">
          <p>
            © <span>Copyright</span> <strong className="px-1 sitename">Cloudata</strong>{" "}
            <span>Todos los derechos reservados</span>
          </p>
          <div className="credits">
            Desarrollado por <a href="#">Cloudata</a>
          </div>
        </div>
      </div>
    </footer>
  );
});

Footer.displayName = 'Footer';

export default Footer;